import { LegacyComponentDefinition } from '@kizi/comparator-core';
import { AccordionItem } from '@kizi/shared-components';

type Content = {
  labels: string[];
  content: string[];
};

const contentToAccordionItems = (data: Content): AccordionItem[] => {
  const { content, labels } = data;

  let items: AccordionItem[] = [];

  labels.forEach((label, index) => {
    items.push({ label, content: content[index] });
  });
  return items;
};

const rowFields3P: string[][] = [
  ['field_89', 'field_-1'],
  ['field_162', 'field_161'],
];

const fullWidthInputs: string[] = ['radio', 'single_checkbox'];

const getAdditionalDefinition = (components, type: string) => {
  if (type.includes('TriplePlay')) {
    let currentRowCount = 0;
    return components.map((legacyDefinition: LegacyComponentDefinition) => {
      if (
        rowFields3P.find((row, index) => {
          if (row.includes(legacyDefinition.name)) {
            currentRowCount = index + 1;
            return true;
          }
          return false;
        })
      ) {
        return { ...legacyDefinition, row: currentRowCount };
      } else if (
        legacyDefinition.input &&
        !fullWidthInputs.includes(legacyDefinition.type as string)
      ) {
        return {
          ...legacyDefinition,
          props: {
            ...legacyDefinition.props,
            _containerProps: { variant: 'halfWidth' },
          },
        };
      }

      return legacyDefinition;
    });
  }
  return components;
};

const carCoveragesMapping = {
  RB: 'Rechtsbijstandsverzekering',
  SVI: 'Schadeverzekering voor Inzittenden',
  PHEU: 'Pechhulp Buitenland',
  PHEUNL: 'Pechhulp Nederland',
  PHNL: 'Pechhulp Nederland',
  PHNLW: 'Pechhulp Nederland',
  WA: 'Wettelijke Aansprakelijkheid',
  WABEPERKTCASCO: 'WA+ Beperkt Casco',
  WACASCO: 'All risk Volledig Casco',
  CA: 'All risk Volledig Casco',
};

export {
  contentToAccordionItems,
  getAdditionalDefinition,
  carCoveragesMapping,
};
